'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Apollo = require('@apollo/client');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var Apollo__namespace = /*#__PURE__*/_interopNamespace(Apollo);

const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

/** Aliased version name */

/** Metadata assigned to each asset on freighter */

/** An ISO 3166-1 Alpha-2 code of a country from https://www.iso.org/obp/ui/#search */

/** A carrier EDD from EDD Checkout API */

/** EDD Error response types from Narvar */

/** A generic key and value pair of string */

/** Analytics configuration for embedded narvar.js components */

/** Global Settings from Quin */

/** An item in the shipment */

/** An ISO 639-1 code of a language from http://www.loc.gov/standards/iso639-2/php/code_list.php */

/** A list of recommendation from Track-Rec ML API */

/** Marketing asset response from freighter */

/** TODO: deprecate */

/**
 * Narvar.js Translations from Quin
 * TODO: DEPRECATE when `narvarjs` updated to use retailerTranslations query
 */

/** The status of the shipment mapped by Narvar */

/** Notification Pref Detail */

/** Product recommendations configuration */

/** Certona product recommendations configuration */

/** JSON API product recommendations configuration */

/** JSON API product recommendations configuration */

/** JSON API product recommendations formatting options */

/** JSON API product recommendations Item JSON property to UI render mapping */

/** JSON API product recommendations UI rendering options */

/** ML Engine product recommendations configuration */

/** Custom JavaScript product recommendations configuration */

/** The type of product recommendations to render */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Courier Location API data */

/** Narvar.js Settings from Quin */

/** Retailer Translations from Quin settings table */

/** Segmented Experience properties */

/** A settings response from Quin Settings API */

/** Shipment information from Order Tracking API */

/** Shipment information from Order Tracking API */

/** A carrier EDD from Tracking Info API */

/** A carrier EDD from Tracking Info API */

/** An event that occured related to the shipment */

/** The actual type of shipment tracking determined by tracksuit logic */

/** The type of tracking possibly defined in URL parameters */

const GetMarketingAssetDocument = Apollo.gql`
  query GetMarketingAsset($id: ID!, $language: String, $country: String) {
    getMarketingAsset(id: $id, language: $language, country: $country) {
      category
      destinationUrl
      altText
      cdnUrl
    }
  }
`;

/**
 * __useGetMarketingAssetQuery__
 *
 * To run a query within a React component, call `useGetMarketingAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      country: // value for 'country'
 *   },
 * });
 */
function useGetMarketingAssetQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetMarketingAssetDocument, options);
}
function useGetMarketingAssetLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetMarketingAssetDocument, options);
}
const CourierLocationDocument = Apollo.gql`
  query CourierLocation(
    $courier: String
    $trackingNumber: String!
    $limit: Int
  ) {
    courierLocation(
      courier: $courier
      trackingNumber: $trackingNumber
      limit: $limit
    ) {
      courierName
      trackingNumber
      courierLocationEvents {
        eventTimestamp
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useCourierLocationQuery__
 *
 * To run a query within a React component, call `useCourierLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourierLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourierLocationQuery({
 *   variables: {
 *      courier: // value for 'courier'
 *      trackingNumber: // value for 'trackingNumber'
 *      limit: // value for 'limit'
 *   },
 * });
 */
function useCourierLocationQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(CourierLocationDocument, options);
}
function useCourierLocationLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(CourierLocationDocument, options);
}
const MaptilerDocument = Apollo.gql`
  query Maptiler {
    maptiler {
      key
    }
  }
`;

/**
 * __useMaptilerQuery__
 *
 * To run a query within a React component, call `useMaptilerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaptilerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaptilerQuery({
 *   variables: {
 *   },
 * });
 */
function useMaptilerQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(MaptilerDocument, options);
}
function useMaptilerLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(MaptilerDocument, options);
}
const IsGrowthBookFeatureOnDocument = Apollo.gql`
  query IsGrowthBookFeatureOn(
    $project: GrowthBookProject!
    $feature: String!
    $attributes: JSONObject!
    $anonymousId: String
    $sourceWriteKey: String
  ) {
    isGrowthBookFeatureOn(
      project: $project
      feature: $feature
      attributes: $attributes
      anonymousId: $anonymousId
      sourceWriteKey: $sourceWriteKey
    )
  }
`;

/**
 * __useIsGrowthBookFeatureOnQuery__
 *
 * To run a query within a React component, call `useIsGrowthBookFeatureOnQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsGrowthBookFeatureOnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsGrowthBookFeatureOnQuery({
 *   variables: {
 *      project: // value for 'project'
 *      feature: // value for 'feature'
 *      attributes: // value for 'attributes'
 *      anonymousId: // value for 'anonymousId'
 *      sourceWriteKey: // value for 'sourceWriteKey'
 *   },
 * });
 */
function useIsGrowthBookFeatureOnQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(IsGrowthBookFeatureOnDocument, options);
}
function useIsGrowthBookFeatureOnLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(IsGrowthBookFeatureOnDocument, options);
}
const GetDefaultLocaleDocument = Apollo.gql`
  query GetDefaultLocale($retailerMoniker: String!) {
    globalSettings(product: "global", retailerMoniker: $retailerMoniker) {
      defaultLanguage
      defaultCountry
    }
  }
`;

/**
 * __useGetDefaultLocaleQuery__
 *
 * To run a query within a React component, call `useGetDefaultLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultLocaleQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *   },
 * });
 */
function useGetDefaultLocaleQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetDefaultLocaleDocument, options);
}
function useGetDefaultLocaleLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetDefaultLocaleDocument, options);
}
const GetClaimAgentDocument = Apollo.gql`
  query GetClaimAgent(
    $retailerMoniker: String!
    $id: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $timezone: String!
  ) {
    claimAgent(
      retailerMoniker: $retailerMoniker
      id: $id
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      timezone: $timezone
    ) {
      claim {
        id
        orderNumber
        status
        createdOn
        updatedOn
        claimType
        recommendedAction
        referenceNumber
        claimAmount {
          currency
          value
        }
        irisStatus
        irisRecommendations {
          message
          action
        }
        policyRulesMatched {
          agentMessage
          action
        }
        resolution {
          action
          actionReason
          reviewer
          resolvedOn
        }
        shipments {
          serviceDescription
          status
          statusCode
          trackingNumber
          eddFormatted
          trackingUrl
          carrier
          detailedReason
          detailedReasonOtherText
          comments
          photos {
            url
          }
          history {
            description
            formattedDescription {
              value
            }
            date
            dateFormatted
            city
            state
          }
        }
        items {
          name
          sku
          quantity
          color
          size
          price
          itemImage
          trackingNumber
          comments
          detailedReason
          detailedReasonOtherText
          photos {
            url
          }
        }
        customer {
          phone
          email
          billingAddress {
            street1
            street2
            city
            state
            zip
          }
          shippingAddress {
            street1
            street2
            city
            state
            zip
          }
        }
      }
    }
  }
`;

/**
 * __useGetClaimAgentQuery__
 *
 * To run a query within a React component, call `useGetClaimAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimAgentQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      id: // value for 'id'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
function useGetClaimAgentQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetClaimAgentDocument, options);
}
function useGetClaimAgentLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetClaimAgentDocument, options);
}
const GetClaimEligibilityDocument = Apollo.gql`
  query GetClaimEligibility(
    $retailerMoniker: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $orderNumber: String!
    $email: String!
    $claimType: ClaimType!
    $cartId: String
  ) {
    claimEligibility(
      retailerMoniker: $retailerMoniker
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      orderNumber: $orderNumber
      email: $email
      claimType: $claimType
      cartId: $cartId
    ) {
      showOtpFlow
      last4Phone
      encryptedPhone
      email
      orderNumber
      retailerMoniker
      verificationJwt
      deliveryProtectionCovered
      claimTypeConfig {
        comment {
          required
          show
        }
        photos {
          required
          show
        }
        deliveryConfirmation {
          required
          show
        }
        safeToShipConfirmation {
          required
          show
        }
        detailedReason {
          required
          show
        }
      }
      items {
        uid
        itemId
        sku
        currency
        maxClaimableQuantity
        name
        color
        size
        thumbnailUrl
        unitPrice
        unitTax
      }
      shipments {
        eligibility {
          ineligibilityReasons {
            reason
            reasonMessage
          }
          isEligible
          type
        }
        id
        items {
          itemRefId
          itemId
          quantity
          sku
          eligibility {
            eligibleQuantity
            ineligibilityReason {
              reason
              quantity
              reasonMessage
            }
            isEligible
            type
          }
        }
        edd {
          begin
        }
        status
        statusCode
        trackingNumber
      }
    }
  }
`;

/**
 * __useGetClaimEligibilityQuery__
 *
 * To run a query within a React component, call `useGetClaimEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimEligibilityQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      orderNumber: // value for 'orderNumber'
 *      email: // value for 'email'
 *      claimType: // value for 'claimType'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useGetClaimEligibilityQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetClaimEligibilityDocument, options);
}
function useGetClaimEligibilityLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetClaimEligibilityDocument, options);
}
const GetClaimEligibilityAgentDocument = Apollo.gql`
  query GetClaimEligibilityAgent(
    $retailerMoniker: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $orderNumber: String!
    $email: String!
    $claimType: ClaimType!
  ) {
    claimEligibilityAgent(
      retailerMoniker: $retailerMoniker
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      orderNumber: $orderNumber
      email: $email
      claimType: $claimType
    ) {
      showOtpFlow
      email
      orderNumber
      retailerMoniker
      claimTypeConfig {
        comment {
          required
          show
        }
        photos {
          required
          show
        }
        deliveryConfirmation {
          required
          show
        }
        safeToShipConfirmation {
          required
          show
        }
        detailedReason {
          required
          show
        }
      }
      items {
        uid
        itemId
        sku
        currency
        maxClaimableQuantity
        name
        color
        size
        thumbnailUrl
        unitPrice
        unitTax
      }
      shipments {
        eligibility {
          ineligibilityReasons {
            reason
            reasonMessage
            allowAgentOverride
          }
          isEligible
          type
        }
        id
        items {
          itemRefId
          itemId
          quantity
          sku
          eligibility {
            eligibleQuantity
            ineligibilityReason {
              reason
              quantity
              reasonMessage
              allowAgentOverride
            }
            isEligible
            type
          }
        }
        edd {
          begin
        }
        status
        statusCode
        trackingNumber
      }
    }
  }
`;

/**
 * __useGetClaimEligibilityAgentQuery__
 *
 * To run a query within a React component, call `useGetClaimEligibilityAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimEligibilityAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimEligibilityAgentQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      orderNumber: // value for 'orderNumber'
 *      email: // value for 'email'
 *      claimType: // value for 'claimType'
 *   },
 * });
 */
function useGetClaimEligibilityAgentQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetClaimEligibilityAgentDocument, options);
}
function useGetClaimEligibilityAgentLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetClaimEligibilityAgentDocument, options);
}
const GetClaimsOverviewAgentDocument = Apollo.gql`
  query GetClaimsOverviewAgent(
    $retailerMoniker: String!
    $orderNumber: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $timezone: String!
  ) {
    claimsOverviewAgent(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      timezone: $timezone
    ) {
      claimsExistOnCase
      orderClaimsNotInCase {
        id
        referenceNumber
        orderNumber
        status
        createdOn
        updatedOn
        claimType
        items {
          name
          itemImage
          photos {
            url
          }
        }
      }
      orderClaimsInCase {
        id
        referenceNumber
        orderNumber
        status
        createdOn
        updatedOn
        claimType
        items {
          name
          itemImage
          photos {
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetClaimsOverviewAgentQuery__
 *
 * To run a query within a React component, call `useGetClaimsOverviewAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimsOverviewAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimsOverviewAgentQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      orderNumber: // value for 'orderNumber'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
function useGetClaimsOverviewAgentQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetClaimsOverviewAgentDocument, options);
}
function useGetClaimsOverviewAgentLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetClaimsOverviewAgentDocument, options);
}
const CreateClaimDocument = Apollo.gql`
  mutation CreateClaim(
    $email: String!
    $orderNumber: String!
    $retailerMoniker: String!
    $claimType: ClaimType!
    $referenceNumber: String
    $items: [CreateClaimItem!]
    $shipments: [CreateClaimShipment!]
    $locale: String!
    $appeasement: CreateClaimAppeasement
    $otpVerification: CreateClaimOtpVerification
    $cartId: String
    $source: String
  ) {
    createClaim(
      email: $email
      orderNumber: $orderNumber
      retailerMoniker: $retailerMoniker
      claimType: $claimType
      referenceNumber: $referenceNumber
      items: $items
      shipments: $shipments
      locale: $locale
      appeasement: $appeasement
      otpVerification: $otpVerification
      cartId: $cartId
      source: $source
    ) {
      success
    }
  }
`;
/**
 * __useCreateClaimMutation__
 *
 * To run a mutation, you first call `useCreateClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClaimMutation, { data, loading, error }] = useCreateClaimMutation({
 *   variables: {
 *      email: // value for 'email'
 *      orderNumber: // value for 'orderNumber'
 *      retailerMoniker: // value for 'retailerMoniker'
 *      claimType: // value for 'claimType'
 *      referenceNumber: // value for 'referenceNumber'
 *      items: // value for 'items'
 *      shipments: // value for 'shipments'
 *      locale: // value for 'locale'
 *      appeasement: // value for 'appeasement'
 *      otpVerification: // value for 'otpVerification'
 *      cartId: // value for 'cartId'
 *      source: // value for 'source'
 *   },
 * });
 */
function useCreateClaimMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(CreateClaimDocument, options);
}
const CreateClaimAgentDocument = Apollo.gql`
  mutation CreateClaimAgent(
    $email: String!
    $orderNumber: String!
    $retailerMoniker: String!
    $claimType: ClaimType!
    $referenceNumber: String
    $items: [CreateClaimItem!]
    $shipments: [CreateClaimShipment!]
    $locale: String!
    $appeasement: CreateClaimAppeasement
    $cartId: String
    $source: String
  ) {
    createClaimAgent(
      email: $email
      orderNumber: $orderNumber
      retailerMoniker: $retailerMoniker
      claimType: $claimType
      referenceNumber: $referenceNumber
      items: $items
      shipments: $shipments
      locale: $locale
      appeasement: $appeasement
      cartId: $cartId
      source: $source
    ) {
      success
    }
  }
`;
/**
 * __useCreateClaimAgentMutation__
 *
 * To run a mutation, you first call `useCreateClaimAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClaimAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClaimAgentMutation, { data, loading, error }] = useCreateClaimAgentMutation({
 *   variables: {
 *      email: // value for 'email'
 *      orderNumber: // value for 'orderNumber'
 *      retailerMoniker: // value for 'retailerMoniker'
 *      claimType: // value for 'claimType'
 *      referenceNumber: // value for 'referenceNumber'
 *      items: // value for 'items'
 *      shipments: // value for 'shipments'
 *      locale: // value for 'locale'
 *      appeasement: // value for 'appeasement'
 *      cartId: // value for 'cartId'
 *      source: // value for 'source'
 *   },
 * });
 */
function useCreateClaimAgentMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(CreateClaimAgentDocument, options);
}
const FormatShipmentEddDocument = Apollo.gql`
  query FormatShipmentEdd(
    $eddCombos: [DisplayDateFormatCombo!]!
    $retailerMoniker: String!
    $versionName: String
    $localeLanguage: Language
    $localeCountry: Country
  ) {
    formatEdd(
      product: "claims_translations"
      eddCombos: $eddCombos
      retailerMoniker: $retailerMoniker
      versionName: $versionName
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
    ) {
      formattedEdds
    }
  }
`;

/**
 * __useFormatShipmentEddQuery__
 *
 * To run a query within a React component, call `useFormatShipmentEddQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormatShipmentEddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormatShipmentEddQuery({
 *   variables: {
 *      eddCombos: // value for 'eddCombos'
 *      retailerMoniker: // value for 'retailerMoniker'
 *      versionName: // value for 'versionName'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *   },
 * });
 */
function useFormatShipmentEddQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(FormatShipmentEddDocument, options);
}
function useFormatShipmentEddLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(FormatShipmentEddDocument, options);
}
const OrderLookupHeroImageDocument = Apollo.gql`
  query OrderLookupHeroImage($id: ID!, $language: String, $country: String) {
    getMarketingAsset(id: $id, language: $language, country: $country) {
      category
      destinationUrl
      altText
      cdnUrl
    }
  }
`;

/**
 * __useOrderLookupHeroImageQuery__
 *
 * To run a query within a React component, call `useOrderLookupHeroImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderLookupHeroImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderLookupHeroImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      country: // value for 'country'
 *   },
 * });
 */
function useOrderLookupHeroImageQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(OrderLookupHeroImageDocument, options);
}
function useOrderLookupHeroImageLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(OrderLookupHeroImageDocument, options);
}
const OtpSendDocument = Apollo.gql`
  mutation OtpSend(
    $retailerMoniker: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $orderNumber: String!
    $phone: String
    $encryptedPhone: String
  ) {
    otpSend(
      retailerMoniker: $retailerMoniker
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      orderNumber: $orderNumber
      phone: $phone
      encryptedPhone: $encryptedPhone
    ) {
      success
    }
  }
`;
/**
 * __useOtpSendMutation__
 *
 * To run a mutation, you first call `useOtpSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpSendMutation, { data, loading, error }] = useOtpSendMutation({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      orderNumber: // value for 'orderNumber'
 *      phone: // value for 'phone'
 *      encryptedPhone: // value for 'encryptedPhone'
 *   },
 * });
 */
function useOtpSendMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(OtpSendDocument, options);
}
const OtpVerifyDocument = Apollo.gql`
  mutation OtpVerify(
    $retailerMoniker: String!
    $code: String!
    $orderNumber: String!
    $phone: String
    $encryptedPhone: String
  ) {
    otpVerify(
      retailerMoniker: $retailerMoniker
      code: $code
      orderNumber: $orderNumber
      phone: $phone
      encryptedPhone: $encryptedPhone
    ) {
      success
      otpJwt
    }
  }
`;
/**
 * __useOtpVerifyMutation__
 *
 * To run a mutation, you first call `useOtpVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpVerifyMutation, { data, loading, error }] = useOtpVerifyMutation({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      code: // value for 'code'
 *      orderNumber: // value for 'orderNumber'
 *      phone: // value for 'phone'
 *      encryptedPhone: // value for 'encryptedPhone'
 *   },
 * });
 */
function useOtpVerifyMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(OtpVerifyDocument, options);
}
const GetTrackSegmentedExperienceForClaimsDocument = Apollo.gql`
  query GetTrackSegmentedExperienceForClaims(
    $retailerMoniker: String!
    $localeLanguage: Language
    $localeCountry: Country
    $versionName: String
  ) {
    segmentedExperience(
      retailerMoniker: $retailerMoniker
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      versionName: $versionName
    ) {
      versionName
    }
  }
`;

/**
 * __useGetTrackSegmentedExperienceForClaimsQuery__
 *
 * To run a query within a React component, call `useGetTrackSegmentedExperienceForClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackSegmentedExperienceForClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackSegmentedExperienceForClaimsQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      versionName: // value for 'versionName'
 *   },
 * });
 */
function useGetTrackSegmentedExperienceForClaimsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetTrackSegmentedExperienceForClaimsDocument, options);
}
function useGetTrackSegmentedExperienceForClaimsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetTrackSegmentedExperienceForClaimsDocument, options);
}
const GetSignedUploadLinkDocument = Apollo.gql`
  query GetSignedUploadLink($photoDetails: [SignedUploadLinkPhotoDetails!]!) {
    signedUploadLink(photoDetails: $photoDetails) {
      signedUrl
      contentType
      imageKey
    }
  }
`;

/**
 * __useGetSignedUploadLinkQuery__
 *
 * To run a query within a React component, call `useGetSignedUploadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUploadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUploadLinkQuery({
 *   variables: {
 *      photoDetails: // value for 'photoDetails'
 *   },
 * });
 */
function useGetSignedUploadLinkQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetSignedUploadLinkDocument, options);
}
function useGetSignedUploadLinkLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetSignedUploadLinkDocument, options);
}
const UpdateClaimAgentDocument = Apollo.gql`
  mutation UpdateClaimAgent(
    $retailerMoniker: String!
    $id: String!
    $localeLanguage: Language!
    $localeCountry: Country!
    $timezone: String!
    $action: ClaimAction!
    $actionReason: String
  ) {
    updateClaimAgent(
      retailerMoniker: $retailerMoniker
      id: $id
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      timezone: $timezone
      action: $action
      actionReason: $actionReason
    ) {
      success
      claim {
        id
        status
        updatedOn
        resolution {
          action
          actionReason
          reviewer
          resolvedOn
        }
      }
    }
  }
`;
/**
 * __useUpdateClaimAgentMutation__
 *
 * To run a mutation, you first call `useUpdateClaimAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClaimAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClaimAgentMutation, { data, loading, error }] = useUpdateClaimAgentMutation({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      id: // value for 'id'
 *      localeLanguage: // value for 'localeLanguage'
 *      localeCountry: // value for 'localeCountry'
 *      timezone: // value for 'timezone'
 *      action: // value for 'action'
 *      actionReason: // value for 'actionReason'
 *   },
 * });
 */
function useUpdateClaimAgentMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(UpdateClaimAgentDocument, options);
}
const GetDecodedParamsDocument = Apollo.gql`
  query GetDecodedParams($retailer: String!, $token: String!) {
    decodeToken(retailer: $retailer, token: $token) {
      key
      value
    }
  }
`;

/**
 * __useGetDecodedParamsQuery__
 *
 * To run a query within a React component, call `useGetDecodedParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDecodedParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecodedParamsQuery({
 *   variables: {
 *      retailer: // value for 'retailer'
 *      token: // value for 'token'
 *   },
 * });
 */
function useGetDecodedParamsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetDecodedParamsDocument, options);
}
function useGetDecodedParamsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetDecodedParamsDocument, options);
}
const GetNotificationPreferencesAndLevelDocument = Apollo.gql`
  query GetNotificationPreferencesAndLevel(
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
    $referrerUrl: String
  ) {
    getNotificationPreferencesAndLevel(
      product: "global"
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
      referrerUrl: $referrerUrl
    ) {
      lineLoginUrl
      preferenceLevel
      modifiedDatetime
      isGuest
      isActive
      notificationPrefDetails {
        contact
        channel
      }
    }
  }
`;

/**
 * __useGetNotificationPreferencesAndLevelQuery__
 *
 * To run a query within a React component, call `useGetNotificationPreferencesAndLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationPreferencesAndLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationPreferencesAndLevelQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      trackingNumbers: // value for 'trackingNumbers'
 *      orderNumbers: // value for 'orderNumbers'
 *      versionName: // value for 'versionName'
 *      carrier: // value for 'carrier'
 *      type: // value for 'type'
 *      orderApiEnabled: // value for 'orderApiEnabled'
 *      localeCountry: // value for 'localeCountry'
 *      localeLanguage: // value for 'localeLanguage'
 *      destinationZip: // value for 'destinationZip'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      secured: // value for 'secured'
 *      originZip: // value for 'originZip'
 *      originCountry: // value for 'originCountry'
 *      destinationCountry: // value for 'destinationCountry'
 *      service: // value for 'service'
 *      orderDate: // value for 'orderDate'
 *      shipDate: // value for 'shipDate'
 *      retailerDcId: // value for 'retailerDcId'
 *      productCategory: // value for 'productCategory'
 *      promiseDate: // value for 'promiseDate'
 *      hipaaCompliant: // value for 'hipaaCompliant'
 *      referrerUrl: // value for 'referrerUrl'
 *   },
 * });
 */
function useGetNotificationPreferencesAndLevelQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetNotificationPreferencesAndLevelDocument, options);
}
function useGetNotificationPreferencesAndLevelLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetNotificationPreferencesAndLevelDocument, options);
}
const UpdateNotificationPreferencesAllLevelsDocument = Apollo.gql`
  mutation UpdateNotificationPreferencesAllLevels(
    $preferenceLevel: NotificationPreferenceLevel!
    $isActive: String
    $isGuest: String
    $channel: String
    $trackingNumber: String
    $orderId: String
    $modifiedDatetime: String
    $referrerUrl: String
    $notificationPrefDetails: [NotificationPrefDetailsInput]
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
    $marketingOptInChecked: Boolean
  ) {
    updateNotificationPreferencesAllLevels(
      preferenceLevel: $preferenceLevel
      isActive: $isActive
      isGuest: $isGuest
      channel: $channel
      trackingNumber: $trackingNumber
      orderId: $orderId
      modifiedDatetime: $modifiedDatetime
      referrerUrl: $referrerUrl
      notificationPrefDetails: $notificationPrefDetails
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
      marketingOptInChecked: $marketingOptInChecked
    )
  }
`;
/**
 * __useUpdateNotificationPreferencesAllLevelsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesAllLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesAllLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesAllLevelsMutation, { data, loading, error }] = useUpdateNotificationPreferencesAllLevelsMutation({
 *   variables: {
 *      preferenceLevel: // value for 'preferenceLevel'
 *      isActive: // value for 'isActive'
 *      isGuest: // value for 'isGuest'
 *      channel: // value for 'channel'
 *      trackingNumber: // value for 'trackingNumber'
 *      orderId: // value for 'orderId'
 *      modifiedDatetime: // value for 'modifiedDatetime'
 *      referrerUrl: // value for 'referrerUrl'
 *      notificationPrefDetails: // value for 'notificationPrefDetails'
 *      retailerMoniker: // value for 'retailerMoniker'
 *      trackingNumbers: // value for 'trackingNumbers'
 *      orderNumbers: // value for 'orderNumbers'
 *      versionName: // value for 'versionName'
 *      carrier: // value for 'carrier'
 *      type: // value for 'type'
 *      orderApiEnabled: // value for 'orderApiEnabled'
 *      localeCountry: // value for 'localeCountry'
 *      localeLanguage: // value for 'localeLanguage'
 *      destinationZip: // value for 'destinationZip'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      secured: // value for 'secured'
 *      originZip: // value for 'originZip'
 *      originCountry: // value for 'originCountry'
 *      destinationCountry: // value for 'destinationCountry'
 *      service: // value for 'service'
 *      orderDate: // value for 'orderDate'
 *      shipDate: // value for 'shipDate'
 *      retailerDcId: // value for 'retailerDcId'
 *      productCategory: // value for 'productCategory'
 *      promiseDate: // value for 'promiseDate'
 *      hipaaCompliant: // value for 'hipaaCompliant'
 *      marketingOptInChecked: // value for 'marketingOptInChecked'
 *   },
 * });
 */
function useUpdateNotificationPreferencesAllLevelsMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(UpdateNotificationPreferencesAllLevelsDocument, options);
}
const UnsubscribeNotificationPreferencesAllLevelsDocument = Apollo.gql`
  mutation UnsubscribeNotificationPreferencesAllLevels(
    $preferenceLevel: NotificationPreferenceLevel!
    $isActive: String
    $isGuest: String
    $channel: String!
    $trackingNumber: String
    $orderId: String
    $modifiedDatetime: String
    $referrerUrl: String
    $notificationPrefDetails: [NotificationPrefDetailsInput]
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
  ) {
    unsubscribeNotificationPreferencesAllLevels(
      preferenceLevel: $preferenceLevel
      isActive: $isActive
      isGuest: $isGuest
      channel: $channel
      trackingNumber: $trackingNumber
      orderId: $orderId
      modifiedDatetime: $modifiedDatetime
      referrerUrl: $referrerUrl
      notificationPrefDetails: $notificationPrefDetails
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
    )
  }
`;
/**
 * __useUnsubscribeNotificationPreferencesAllLevelsMutation__
 *
 * To run a mutation, you first call `useUnsubscribeNotificationPreferencesAllLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeNotificationPreferencesAllLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeNotificationPreferencesAllLevelsMutation, { data, loading, error }] = useUnsubscribeNotificationPreferencesAllLevelsMutation({
 *   variables: {
 *      preferenceLevel: // value for 'preferenceLevel'
 *      isActive: // value for 'isActive'
 *      isGuest: // value for 'isGuest'
 *      channel: // value for 'channel'
 *      trackingNumber: // value for 'trackingNumber'
 *      orderId: // value for 'orderId'
 *      modifiedDatetime: // value for 'modifiedDatetime'
 *      referrerUrl: // value for 'referrerUrl'
 *      notificationPrefDetails: // value for 'notificationPrefDetails'
 *      retailerMoniker: // value for 'retailerMoniker'
 *      trackingNumbers: // value for 'trackingNumbers'
 *      orderNumbers: // value for 'orderNumbers'
 *      versionName: // value for 'versionName'
 *      carrier: // value for 'carrier'
 *      type: // value for 'type'
 *      orderApiEnabled: // value for 'orderApiEnabled'
 *      localeCountry: // value for 'localeCountry'
 *      localeLanguage: // value for 'localeLanguage'
 *      destinationZip: // value for 'destinationZip'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      secured: // value for 'secured'
 *      originZip: // value for 'originZip'
 *      originCountry: // value for 'originCountry'
 *      destinationCountry: // value for 'destinationCountry'
 *      service: // value for 'service'
 *      orderDate: // value for 'orderDate'
 *      shipDate: // value for 'shipDate'
 *      retailerDcId: // value for 'retailerDcId'
 *      productCategory: // value for 'productCategory'
 *      promiseDate: // value for 'promiseDate'
 *      hipaaCompliant: // value for 'hipaaCompliant'
 *   },
 * });
 */
function useUnsubscribeNotificationPreferencesAllLevelsMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(UnsubscribeNotificationPreferencesAllLevelsDocument, options);
}
const GetUserPrefsNotificationPreferencesDocument = Apollo.gql`
  query GetUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    getUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
    ) {
      optIns {
        level
        preferences {
          status
        }
      }
      profileId
    }
  }
`;

/**
 * __useGetUserPrefsNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPrefsNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPrefsNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPrefsNotificationPreferencesQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      orderNumber: // value for 'orderNumber'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
function useGetUserPrefsNotificationPreferencesQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetUserPrefsNotificationPreferencesDocument, options);
}
function useGetUserPrefsNotificationPreferencesLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetUserPrefsNotificationPreferencesDocument, options);
}
const GetUserPrefsNotificationPreferencesEligibilityDocument = Apollo.gql`
  query GetUserPrefsNotificationPreferencesEligibility(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    getUserPrefsNotificationPreferencesEligibility(
      retailerMoniker: $retailerMoniker
      carrier: $carrier
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
    ) {
      eligible
    }
  }
`;

/**
 * __useGetUserPrefsNotificationPreferencesEligibilityQuery__
 *
 * To run a query within a React component, call `useGetUserPrefsNotificationPreferencesEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPrefsNotificationPreferencesEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPrefsNotificationPreferencesEligibilityQuery({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      orderNumber: // value for 'orderNumber'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
function useGetUserPrefsNotificationPreferencesEligibilityQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetUserPrefsNotificationPreferencesEligibilityDocument, options);
}
function useGetUserPrefsNotificationPreferencesEligibilityLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetUserPrefsNotificationPreferencesEligibilityDocument, options);
}
const SubscribeUserPrefsNotificationPreferencesDocument = Apollo.gql`
  mutation SubscribeUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $notificationPrefDetails: [NotificationPrefDetailsInput!]!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
    $lineageMetadata: LineageMetadataInput!
  ) {
    subscribeUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
      notificationPrefDetails: $notificationPrefDetails
      lineageMetadata: $lineageMetadata
    ) {
      profileId
    }
  }
`;
/**
 * __useSubscribeUserPrefsNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useSubscribeUserPrefsNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeUserPrefsNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeUserPrefsNotificationPreferencesMutation, { data, loading, error }] = useSubscribeUserPrefsNotificationPreferencesMutation({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      notificationPrefDetails: // value for 'notificationPrefDetails'
 *      orderNumber: // value for 'orderNumber'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrier: // value for 'carrier'
 *      lineageMetadata: // value for 'lineageMetadata'
 *   },
 * });
 */
function useSubscribeUserPrefsNotificationPreferencesMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(SubscribeUserPrefsNotificationPreferencesDocument, options);
}
const UnsubscribeUserPrefsNotificationPreferencesDocument = Apollo.gql`
  mutation UnsubscribeUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    unsubscribeUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
    )
  }
`;
/**
 * __useUnsubscribeUserPrefsNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUnsubscribeUserPrefsNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeUserPrefsNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeUserPrefsNotificationPreferencesMutation, { data, loading, error }] = useUnsubscribeUserPrefsNotificationPreferencesMutation({
 *   variables: {
 *      retailerMoniker: // value for 'retailerMoniker'
 *      orderNumber: // value for 'orderNumber'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
function useUnsubscribeUserPrefsNotificationPreferencesMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(UnsubscribeUserPrefsNotificationPreferencesDocument, options);
}

exports.CourierLocationDocument = CourierLocationDocument;
exports.CreateClaimAgentDocument = CreateClaimAgentDocument;
exports.CreateClaimDocument = CreateClaimDocument;
exports.FormatShipmentEddDocument = FormatShipmentEddDocument;
exports.GetClaimAgentDocument = GetClaimAgentDocument;
exports.GetClaimEligibilityAgentDocument = GetClaimEligibilityAgentDocument;
exports.GetClaimEligibilityDocument = GetClaimEligibilityDocument;
exports.GetClaimsOverviewAgentDocument = GetClaimsOverviewAgentDocument;
exports.GetDecodedParamsDocument = GetDecodedParamsDocument;
exports.GetDefaultLocaleDocument = GetDefaultLocaleDocument;
exports.GetMarketingAssetDocument = GetMarketingAssetDocument;
exports.GetNotificationPreferencesAndLevelDocument = GetNotificationPreferencesAndLevelDocument;
exports.GetSignedUploadLinkDocument = GetSignedUploadLinkDocument;
exports.GetTrackSegmentedExperienceForClaimsDocument = GetTrackSegmentedExperienceForClaimsDocument;
exports.GetUserPrefsNotificationPreferencesDocument = GetUserPrefsNotificationPreferencesDocument;
exports.GetUserPrefsNotificationPreferencesEligibilityDocument = GetUserPrefsNotificationPreferencesEligibilityDocument;
exports.IsGrowthBookFeatureOnDocument = IsGrowthBookFeatureOnDocument;
exports.MaptilerDocument = MaptilerDocument;
exports.OrderLookupHeroImageDocument = OrderLookupHeroImageDocument;
exports.OtpSendDocument = OtpSendDocument;
exports.OtpVerifyDocument = OtpVerifyDocument;
exports.SubscribeUserPrefsNotificationPreferencesDocument = SubscribeUserPrefsNotificationPreferencesDocument;
exports.UnsubscribeNotificationPreferencesAllLevelsDocument = UnsubscribeNotificationPreferencesAllLevelsDocument;
exports.UnsubscribeUserPrefsNotificationPreferencesDocument = UnsubscribeUserPrefsNotificationPreferencesDocument;
exports.UpdateClaimAgentDocument = UpdateClaimAgentDocument;
exports.UpdateNotificationPreferencesAllLevelsDocument = UpdateNotificationPreferencesAllLevelsDocument;
exports.useCourierLocationLazyQuery = useCourierLocationLazyQuery;
exports.useCourierLocationQuery = useCourierLocationQuery;
exports.useCreateClaimAgentMutation = useCreateClaimAgentMutation;
exports.useCreateClaimMutation = useCreateClaimMutation;
exports.useFormatShipmentEddLazyQuery = useFormatShipmentEddLazyQuery;
exports.useFormatShipmentEddQuery = useFormatShipmentEddQuery;
exports.useGetClaimAgentLazyQuery = useGetClaimAgentLazyQuery;
exports.useGetClaimAgentQuery = useGetClaimAgentQuery;
exports.useGetClaimEligibilityAgentLazyQuery = useGetClaimEligibilityAgentLazyQuery;
exports.useGetClaimEligibilityAgentQuery = useGetClaimEligibilityAgentQuery;
exports.useGetClaimEligibilityLazyQuery = useGetClaimEligibilityLazyQuery;
exports.useGetClaimEligibilityQuery = useGetClaimEligibilityQuery;
exports.useGetClaimsOverviewAgentLazyQuery = useGetClaimsOverviewAgentLazyQuery;
exports.useGetClaimsOverviewAgentQuery = useGetClaimsOverviewAgentQuery;
exports.useGetDecodedParamsLazyQuery = useGetDecodedParamsLazyQuery;
exports.useGetDecodedParamsQuery = useGetDecodedParamsQuery;
exports.useGetDefaultLocaleLazyQuery = useGetDefaultLocaleLazyQuery;
exports.useGetDefaultLocaleQuery = useGetDefaultLocaleQuery;
exports.useGetMarketingAssetLazyQuery = useGetMarketingAssetLazyQuery;
exports.useGetMarketingAssetQuery = useGetMarketingAssetQuery;
exports.useGetNotificationPreferencesAndLevelLazyQuery = useGetNotificationPreferencesAndLevelLazyQuery;
exports.useGetNotificationPreferencesAndLevelQuery = useGetNotificationPreferencesAndLevelQuery;
exports.useGetSignedUploadLinkLazyQuery = useGetSignedUploadLinkLazyQuery;
exports.useGetSignedUploadLinkQuery = useGetSignedUploadLinkQuery;
exports.useGetTrackSegmentedExperienceForClaimsLazyQuery = useGetTrackSegmentedExperienceForClaimsLazyQuery;
exports.useGetTrackSegmentedExperienceForClaimsQuery = useGetTrackSegmentedExperienceForClaimsQuery;
exports.useGetUserPrefsNotificationPreferencesEligibilityLazyQuery = useGetUserPrefsNotificationPreferencesEligibilityLazyQuery;
exports.useGetUserPrefsNotificationPreferencesEligibilityQuery = useGetUserPrefsNotificationPreferencesEligibilityQuery;
exports.useGetUserPrefsNotificationPreferencesLazyQuery = useGetUserPrefsNotificationPreferencesLazyQuery;
exports.useGetUserPrefsNotificationPreferencesQuery = useGetUserPrefsNotificationPreferencesQuery;
exports.useIsGrowthBookFeatureOnLazyQuery = useIsGrowthBookFeatureOnLazyQuery;
exports.useIsGrowthBookFeatureOnQuery = useIsGrowthBookFeatureOnQuery;
exports.useMaptilerLazyQuery = useMaptilerLazyQuery;
exports.useMaptilerQuery = useMaptilerQuery;
exports.useOrderLookupHeroImageLazyQuery = useOrderLookupHeroImageLazyQuery;
exports.useOrderLookupHeroImageQuery = useOrderLookupHeroImageQuery;
exports.useOtpSendMutation = useOtpSendMutation;
exports.useOtpVerifyMutation = useOtpVerifyMutation;
exports.useSubscribeUserPrefsNotificationPreferencesMutation = useSubscribeUserPrefsNotificationPreferencesMutation;
exports.useUnsubscribeNotificationPreferencesAllLevelsMutation = useUnsubscribeNotificationPreferencesAllLevelsMutation;
exports.useUnsubscribeUserPrefsNotificationPreferencesMutation = useUnsubscribeUserPrefsNotificationPreferencesMutation;
exports.useUpdateClaimAgentMutation = useUpdateClaimAgentMutation;
exports.useUpdateNotificationPreferencesAllLevelsMutation = useUpdateNotificationPreferencesAllLevelsMutation;
